import React from 'react';
import { Container, Stack } from '@mui/material';
import { brand } from 'themes/brand';

export const TestPage: React.FC = ({ children }) => {
  const bodyStyle = {
    background: `linear-gradient(180deg, ${brand.surface} 64.93%, rgba(244, 246, 250, 0.00) 100%)`,
    minHeight: '100vh',
    overscrollBehavior: 'contain',
  };

  return (
    <div style={bodyStyle}>
      <Container>
        <Stack spacing={3} p={2}>
          {children}
        </Stack>
      </Container>
    </div>
  );
};
